var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResizeMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.2,
    y: 9.8,
    width: 18.8,
    height: 3,
    fill: "black"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.645508 0.535156H17.6292V11.2196H7.25272L4.47867 13.305V11.2196H0.645508V0.535156Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1987 0.887285C17.2346 0.887285 17.4137 0.895049 17.4137 1.04988V11.0318C17.4137 11.1767 17.2926 11.3129 17.1987 11.3129H7.18411H6.87475L6.63633 11.5163L4.73029 13.1416V12.2002V11.3129H3.87035H1.07492C0.980971 11.3129 0.859935 11.1767 0.859935 11.0316V1.04966C0.859935 0.895049 1.03902 0.887285 1.07492 0.887285H17.1987ZM17.1987 0H1.07492C0.481349 0 0 0.437431 0 1.04988V11.0318C0 11.6445 0.481349 12.2002 1.07492 12.2002H3.87035V14.3363C3.87035 14.5788 3.96817 14.7203 4.11307 14.7203C4.18702 14.7203 4.27323 14.6835 4.36503 14.6043L7.18411 12.2002H17.1987C17.7925 12.2002 18.2736 11.6445 18.2736 11.0316V1.04966C18.2736 0.437431 17.7925 0 17.1987 0Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3359 10.75H6.83482V21.7605H17.5274L20.386 23.9095V21.7605H24.3359V10.75Z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27735 10.7425C7.24036 10.7425 7.05582 10.7505 7.05582 10.91V21.1966C7.05582 21.3459 7.18054 21.4862 7.27735 21.4862H17.597H17.9158L18.1615 21.6958L20.1256 23.3707V22.4006V21.4862H21.0117H23.8923C23.9891 21.4862 24.1139 21.3459 24.1139 21.1964V10.9098C24.1139 10.7505 23.9293 10.7425 23.8923 10.7425H7.27735ZM7.27735 9.82812H23.8923C24.504 9.82812 25 10.2789 25 10.91V21.1966C25 21.828 24.504 22.4006 23.8923 22.4006H21.0117V24.6019C21.0117 24.8518 20.9109 24.9976 20.7616 24.9976C20.6854 24.9976 20.5966 24.9597 20.502 24.878L17.597 22.4006H7.27735C6.66548 22.4006 6.16969 21.828 6.16969 21.1964V10.9098C6.16969 10.2789 6.66548 9.82812 7.27735 9.82812Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeMessage);
export default __webpack_public_path__ + "static/media/resizeMessage.419d511529f9120991413e9ca9dee768.svg";
export { ForwardRef as ReactComponent };